export const addPaymentFields = {
  paidAmount: {
    fieldPath: 'paid_amount',
    fieldReadPath: 'paid_amount',
    name: 'paid_amount',
    label: 'global.paid_amount.label',
    options: [],
    id: 'global__balance',
    rules: ['required', 'numeric', 'payment_less_or_equal_invoice_balance'],
    appendIcon: 'euro-sign',
    fieldAttributes: {
      autocomplete: 'off',
      type: 'number',
      step: '0.01',
    },
    warningRules: [],
    veeValidation: false,
  },
  contact: {
    fieldPath: 'contact',
    fieldReadPath: 'contact',
    name: 'contact',
    label: 'global.contact.label',
    inputType: 'input',
    options: [],
    id: 'contact',
    rules: ['required'],
    veeValidation: false,
  },
  paymentMethodType: {
    fieldPath: 'payment_method_type',
    fieldReadPath: 'payment_method_type',
    name: 'payment_method_type',
    label: 'global.payment_method_type.label',
    defaultValue: 'money_transfer',
    options: [
      {
        text: 'global.payment.cash',
        value: 'cash',
      },
      {
        text: 'global.payment.money_transfer',
        value: 'money_transfer',
      },
      {
        text: 'global.payment.manual_terminal',
        value: 'manual_terminal',
      },
      {
        text: 'global.payment.cheque',
        value: 'cheque',
      },
      {
        text: 'global.payment.sport_cheque',
        value: 'sport_cheque',
      },
      {
        text: 'global.payment.sodexo_cheque',
        value: 'sodexo_cheque',
      },
      {
        text: 'global.payment.clearance',
        value: 'clearance',
      },
      {
        text: 'global.payment.direct_debit',
        value: 'direct_debit',
      },

      {
        text: 'global.payment.custom_2',
        value: 'custom_2',
      },

      {
        text: 'global.payment.custom_4',
        value: 'custom_4',
      },
      {
        text: 'global.payment.custom_5',
        value: 'custom_5',
      },

      {
        text: 'global.payment.custom_8',
        value: 'custom_8',
      },
      {
        text: 'global.payment.custom_9',
        value: 'custom_9',
      },
      {
        text: 'global.payment.custom_10',
        value: 'custom_10',
      },
    ],
    id: 'global__payment-method-type',
    rules: ['required'],
  },
  paymentMethodTypeFR: {
    fieldPath: 'payment_method_type',
    fieldReadPath: 'payment_method_type',
    name: 'payment_method_type',
    label: 'global.payment_method_type.label',
    defaultValue: 'money_transfer',
    options: [
      {
        text: 'global.payment.cash',
        value: 'cash',
      },
      {
        text: 'global.payment.money_transfer',
        value: 'money_transfer',
      },
      {
        text: 'global.payment.manual_terminal',
        value: 'manual_terminal',
      },
      {
        text: 'global.payment.cheque',
        value: 'cheque',
      },
      {
        text: 'global.payment.sport_cheque',
        value: 'sport_cheque',
      },
      {
        text: 'global.payment.sodexo_cheque',
        value: 'sodexo_cheque',
      },
      {
        text: 'global.payment.clearance',
        value: 'clearance',
      },
      {
        text: 'global.payment.direct_debit',
        value: 'direct_debit',
      },
      // Only FR
      {
        text: 'global.payment.custom_1',
        value: 'custom_1',
      },
      {
        text: 'global.payment.custom_2',
        value: 'custom_2',
      },
      // Only FR
      {
        text: 'global.payment.custom_3',
        value: 'custom_3',
      },
      {
        text: 'global.payment.custom_4',
        value: 'custom_4',
      },
      {
        text: 'global.payment.custom_5',
        value: 'custom_5',
      },
      // Only FR
      {
        text: 'global.payment.custom_6',
        value: 'custom_6',
      },
      // Only FR
      {
        text: 'global.payment.custom_7',
        value: 'custom_7',
      },
      {
        text: 'global.payment.custom_8',
        value: 'custom_8',
      },
      {
        text: 'global.payment.custom_9',
        value: 'custom_9',
      },
      {
        text: 'global.payment.custom_10',
        value: 'custom_10',
      },
      {
        text: 'global.payment.custom_11',
        value: 'custom_11',
      },
      {
        text: 'global.payment.custom_12',
        value: 'custom_12',
      },
    ],
    id: 'global__payment-method-type',
    rules: ['required'],
  },

  paymentDate: {
    fieldPath: 'payment_date',
    fieldReadPath: 'payment_date',
    name: 'payment_date',
    inputType: 'datepicker',
    options: [],
    id: 'global-payment__payment_date',
    rules: ['required', 'date', 'date_format:Y-m-d'],
    warningRules: [],
    veeValidation: false,
  },
  paymentTime: {
    fieldPath: 'payment_time',
    fieldReadPath: 'payment_time',
    name: 'payment_time',
    label: 'global.payment_time.label',
    inputType: 'time',
    options: [],
    id: 'global-payment__payment_time',
    veeValidation: true,
    rules: ['nullable'],
    warningRules: [],
  },
};

export interface AddPaymentInterface {
  paid_amount: number;
  contactFullname: string;
  paymentMethodType: string;
  payment_date: string;
  payment_time: string;
}

export type AddPaymentKeys = keyof AddPaymentInterface;
export type AddPaymentErrorObject = Partial<Record<AddPaymentKeys, string[]>>;
